// Note: Required by luic since that pipeline doesn't have a react_app_deploy_env variable set.
// This should be removed once the login-ui is moved to Micro frontend.
window.ENV_CONFIG = {
  REACT_APP_DEPLOY_ENV: process.env.REACT_APP_DEPLOY_ENV
};
